import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function AllFieldsRequiredMessage() {
  return <FormattedMessage id="common.allFieldsRequiredUnlessMarked" />;
}
